import { useQuery } from "react-query";
import { fetchIndexToolsData } from "./api";

export function useIndexTools(filters, options = {}) {
  return useQuery(
    ["fetchIndexToolsData", filters],
    () => fetchIndexToolsData(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 6000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
